import SheetLeaveModalComponent from './sheet-leave-modal.component';

export default function registerSheetLeaveComponent(angular) {
    angular.module('assessmentFrontendControllers').controller('SheetLeaveModalComponent', 
        ['$scope', '$uibModalInstance', 'messages', SheetLeaveModalComponent]
    );
}